import { DateTime } from "luxon";

type ParseDateOptions = {
  zone?: string;
  setZone?: boolean;
};

/**
 * @param {string} [options.zone] - The time zone to use when parsing the date (e.g., 'America/New_York').
 * @param {boolean} [options.setZone] - If true, interprets the input date as being in the specified zone rather than converting it.
 *   For example, use `{ setZone: true }` when you want to keep the original time zone of the input date string
 *   instead of converting it to the system's local time zone.
 **/
export const parseDateToDate = (date: string | Date, options?: ParseDateOptions): DateTime | null => {
  let dateTime: DateTime | null;

  if (typeof date === "string") {
    const isoDate = date.replace(" ", "T");
    dateTime = DateTime.fromISO(isoDate, options);
  } else {
    dateTime = DateTime.fromJSDate(date, options);
  }

  if (!dateTime?.isValid) {
    return null;
  }
  return dateTime;
};

export const parseDateToString = (date: any) => {
  if (typeof date === "string") {
    return DateTime.fromISO(date).toJSDate().toLocaleDateString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
  } else if (date instanceof Date) {
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
  } else {
    return null;
  }
};
